(function () {
    "use strict";

    let app = angular.module("app");

    app.service("modalTabHelper", ModalTabHelper);

    ModalTabHelper.$inject = [];

    function ModalTabHelper() {
        var exports = {
            init: init
        }
           
        function init() {

            $('a[data-toggle="tab"]').on('click', function (e) {
                // there is a bug with the bootstrap tabs and the date-picker
                // having a date-picker element on the page prevents the tabs from working 
                // so we have to explicitly call the tab('show') method

                $(e.target).tab('show');
            });
        }

        return exports;
    }
})();
